import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-cream py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1nbbuxhpkt4hc">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-forest-900 sm:text-4xl" data-id="element-166" data-mp="1ncmyphj0uc8g">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-forest-800 bg-white shadow-xl shadow-earth-700/10" data-id="element-167" data-mp="1x8gmjx26xs5j">
          <div className="flex items-center justify-between gap-4 bg-forest-800 px-6 py-4 sm:px-10" data-id="element-168" data-mp="227b5cz05rgpn">
            <span className="inline-flex items-center gap-2 rounded-full bg-gold-500 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-forest-900" data-id="element-169" data-mp="2wjp9nh2hs2k">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="1mhq1qds25mif" /> Main offer
            </span>
            <span className="text-xs font-bold uppercase tracking-[.14em] text-gold-400" data-id="element-171" data-mp="1howwzpwlae6c">50% off today</span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-172" data-mp="1crejdm7mnas0">
            <div className="flex flex-col gap-6 border-b border-earth-100 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-173" data-mp="17rs65crstuj7">
              <div data-id="element-174" data-mp="25fsm2f9nuv9w">
                <h3 className="text-2xl font-extrabold leading-tight text-forest-900" data-id="element-175" data-mp="25e7n8dgbcq68">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-176" data-mp="20gz9cp2778as">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-177" data-mp="1rfhvldc9jip9">
                <span className="text-sm text-muted" data-id="element-178" data-mp="k2g20rbbwcnr">
                  Regular price <span className="line-through" data-id="element-179" data-mp="g0m3opolvkqr">{priceBefore}</span>
                </span>
                <p className="mt-1 whitespace-nowrap font-display text-5xl font-extrabold text-forest-800" data-id="element-180" data-mp="g2yttq4ip1ew">{price}</p>
                <p className="text-xs font-bold uppercase tracking-[.14em] text-earth-500" data-id="element-181" data-mp="mgkv1trwv280">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="7j288wysmz37">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-183" data-mp="cgu1bub6cr8z">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-600" aria-hidden="true" data-id="element-184" data-mp="3uvd0w5951t7v" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-185" data-mp="3kzt6jna832l8">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-186" data-mp="3bxa95ip7hi6d">
              <span className="inline-flex items-center gap-1.5" data-id="element-187" data-mp="3fyc6tv3h5m68">
                <LockIcon className="h-4 w-4 text-forest-600" aria-hidden="true" data-id="element-188" data-mp="2xatmx9uzocbp" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-189" data-mp="2scs48q1h6f0r">
                <ZapIcon className="h-4 w-4 text-forest-600" aria-hidden="true" data-id="element-190" data-mp="2secw27wenjux" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="31cyd1ym8aqtl">
                <ShieldCheckIcon className="h-4 w-4 text-forest-600" aria-hidden="true" data-id="element-192" data-mp="31et1vo0mf32y" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-193" data-mp="3bbe2zy9iru1i">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}